import { render, staticRenderFns } from "./EditGearItem.vue?vue&type=template&id=44f67511"
import script from "./EditGearItem.vue?vue&type=script&lang=js"
export * from "./EditGearItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports